export const VEHICLE_DETAIL_ELEMENTS_ID = {
  tab: {
    mainTab: 'mainTab',
    leasingAndServices: 'leasingAndServicesSection',
    carOverview:'carOverview'
  }
};
